/* ============================================================
   Store context + hook — the single access point every screen uses. Whichever
   provider is mounted (mock or API-backed) supplies a StoreValue here; callers
   never learn which. See store/index.tsx for the mode switch.
   ============================================================ */
import { createContext, useContext } from 'react';
import type { StoreValue } from './types';

export const StoreContext = createContext<StoreValue | null>(null);

export function useStore(): StoreValue {
  const ctx = useContext(StoreContext);
  if (!ctx) throw new Error('useStore must be used within StoreProvider');
  return ctx;
}
